import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { primaryRoutes } from 'src/clinic/routes'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { ContentContainer } from './ClinicHeaderAndContentStyles'

export default function ClinicHeaderAndContent({ removeLeftMargins }) {
  return (
    <ContentContainer removeLeftMargins={removeLeftMargins}>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {primaryRoutes?.map(({ path, name, Element, exact, ...props }, idx) => {
            return (
              Element && (
                <Route
                  key={idx}
                  path={path}
                  exact={exact}
                  name={name}
                  element={<Element {...props} />}
                />
              )
            )
          })}
        </Routes>
      </Suspense>
    </ContentContainer>
  )
}
